<template>
    <rkm-modal
        :buttons="['cancel', 'save']"
        :loading="loading"
        title='Cadastrar grupo'
        large
        ref="Modal"
        @save="$refs.Form.save()"
    >
        <Form
            :id="id"
            ref="Form"
            @save="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        id: null,
    }),
    methods: {
        open(id) {

            this.id = id

            this.$refs.Modal.show()
        },
        handleExit(grupo) {

            this.$emit('save', grupo)

            this.$refs.Modal.hide()
        },
    },
}
</script>